import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useFetch } from 'shared/api/hooks';
import { Link, Skeleton } from '@mui/material';
import { TypographyWithCopy } from 'shared/components/fields';
export const DeviceInstructionLink = memo(function DeviceInstructionLink(props) {
    const { dev_type, hw_type } = props;
    const [isLoading, response] = useFetch('get_device_instruction', { data: { dev_type, hw_type } });
    if (isLoading) {
        return _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 50 });
    }
    if (response?.instruction != null) {
        return (_jsx(TypographyWithCopy, { label: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F", value: response.instruction, component: _jsx(Link, { href: response.instruction, target: "_blank", rel: "noopener noreferrer", children: "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F" }) }));
    }
    return null;
});
